@if (
  ((role === 'SGRE Admin' || role === 'Sales Rep') &&
  componentData.uid === 'UserProfileInternalRoleParagraphComponent') ||
  ((role === 'Customer Admin' ||
  role === 'Purchaser' ||
  role === 'Requester') &&
  componentData.uid === 'UserProfileExternalRoleParagraphComponent')
  ) {
  <div class="p-para m-4">
    <div [innerHTML]="componentData.content"></div>
  </div>
}